/* eslint-disable no-restricted-globals */

import { CHECK_EMAIL_REMINDER_PARAM } from "src/components/collapsible-header/CollapsibleHeader";
import { getSearchQuery } from "src/utils/urlParams";
import { pushReroll, reroll, setParam } from "./utils";
import globalStore from "src/utils/redux/store";
import { setUpid } from "src/utils/redux/slices/upid";

export type OffersParams = {
  claimedByEmail?: string;
  promoCode?: string;
  enrollmentResult?: string;
  forceReroll?: boolean;
};

function isNoomPremium() {
  return location.pathname.startsWith("/noom-premium");
}
function isOffers() {
  return (
    location.pathname.startsWith("/add-ons/") ||
    location.pathname.startsWith("/en/add-ons/") ||
    location.pathname.startsWith("/offers/") ||
    location.pathname.startsWith("/en/offers/") ||
    location.pathname.startsWith("/in-app-offers/")
  );
}

const linkTo = {
  noomPremium({
    claimedByEmail,
    promoCode,
    enrollmentResult,
    forceReroll,
  }: OffersParams) {
    const queryParams = new URLSearchParams(location.search);

    setParam(queryParams, "claimedByEmail", claimedByEmail);
    setParam(queryParams, "promoCode", promoCode);
    setParam(queryParams, "enrollmentResult", enrollmentResult);
    setParam(queryParams, "rerollMerEx", forceReroll);

    return `/noom-premium/${getSearchQuery(queryParams)}`;
  },
  addOns({ claimedByEmail, enrollmentResult }: OffersParams) {
    const queryParams = new URLSearchParams(location.search);

    setParam(queryParams, "claimedByEmail", claimedByEmail);
    setParam(queryParams, "enrollmentResult", enrollmentResult);

    return `/add-ons${getSearchQuery(queryParams)}`;
  },
  addOnConfirmation(params: OffersParams) {
    return `${linkTo.addOns(params)}#/confirmation`;
  },
  limitedOffer(productId: string) {
    return `${linkTo.addOns({})}#/limitedOffer/${productId}`;
  },
};

export default {
  noomPremium(params: OffersParams) {
    reroll(linkTo.noomPremium(params));
  },
  noomPremiumCustomPlans(params: OffersParams) {
    pushReroll(`${linkTo.noomPremium(params)}#/customPlans`, isNoomPremium);
  },
  addOns({
    upid,
    claimedByEmail,
    enrollmentResult,
    forceReroll,
    showEmailReminder,
  }: OffersParams & { showEmailReminder?: boolean; upid?: string }) {
    const queryParams = new URLSearchParams(location.search);
    // Deprecated -- prefer to use the `upid` Redux state slice instead. This is kept only for
    // back-compat for ESDE flows
    if (upid) {
      // Keep the redux store in sync
      globalStore.dispatch(setUpid(upid));
      setParam(queryParams, "upid", upid);
    }
    setParam(queryParams, "claimedByEmail", claimedByEmail);
    setParam(queryParams, "rerollMerEx", forceReroll);
    setParam(queryParams, "enrollmentResult", enrollmentResult);
    setParam(queryParams, CHECK_EMAIL_REMINDER_PARAM, showEmailReminder);

    reroll(`/add-ons`, queryParams);
  },
  addOnConfirmation(params: OffersParams) {
    pushReroll(linkTo.addOnConfirmation(params), isOffers);
  },
  limitedOffer(productId: string) {
    pushReroll(linkTo.limitedOffer(productId), isOffers);
  },

  fastForwardTrial({
    upid,
    forceReroll,
    showEmailReminder,
  }: {
    /** @deprecated */
    upid?: string;
    forceReroll?: boolean;
    showEmailReminder?: boolean;
  }) {
    const queryParams = new URLSearchParams(location.search);

    // Deprecated -- prefer to use the `upid` Redux state slice instead. This is kept only for
    // back-compat for ESDE flows
    if (upid) {
      // Keep the redux store in sync
      globalStore.dispatch(setUpid(upid));
      setParam(queryParams, "upid", upid);
    }

    setParam(queryParams, "rerollMerEx", forceReroll);
    setParam(queryParams, CHECK_EMAIL_REMINDER_PARAM, showEmailReminder);

    reroll(`/fast-forward-trial/`, queryParams);
  },
};
